<template>
  <div id="overlay" class="overlay">
    <div id="overlay-wrapper" class="overlay__wrapper">
      <div id="overlay-content" class="overlay__content">
        <ul
          id="modal-content"
          class="modal__content-list modal__content-list--autowidth"
        >
          <li class="modal__content-item modal__content-item--close">
            <span
              id="modal-close"
              class="modal__close"
              @click="closeErrorModal"
            ></span>
          </li>
          <li
            :class="{
              'modal__content-item modal__content-item--content': true,
              'modal__content-item--padconsistent': this.errors.countError0 > 0
            }"
          >
            <UploadError
              v-if="this.errors.countError0 > 0"
              :configdata="configdata"
              :errorCount="this.errors.countError0"
              :errorMessage="this.errors.ErrorMessage0"
              :errorFiles="this.errors.ErrorArray0"
              :errorType="0"
            />
            <UploadError
              v-if="this.errors.countError1 > 0"
              :configdata="configdata"
              :errorCount="this.errors.countError1"
              :errorMessage="this.errors.ErrorMessage1"
              :errorFiles="this.errors.ErrorArray1"
              :errorType="1"
            />
            <UploadError
              v-if="this.errors.countError2 > 0"
              :configdata="configdata"
              :errorCount="this.errors.countError2"
              :errorMessage="this.errors.ErrorMessage2"
              :errorFiles="this.errors.ErrorArray2"
              :errorType="2"
            />
            <UploadError
              v-if="this.errors.countError3 > 0"
              :configdata="configdata"
              :errorCount="this.errors.countError3"
              :errorMessage="this.errors.ErrorMessage3"
              :errorFiles="this.errors.ErrorArray3"
              :errorType="3"
            />
            <UploadError
              v-if="this.errors.countError4 > 0"
              :configdata="configdata"
              :errorCount="this.errors.countError4"
              :errorMessage="this.errors.ErrorMessage4"
              :errorFiles="this.errors.ErrorArray4"
              :errorType="4"
            />
            <p
              class="modal__attachments_warning"
              v-if="this.errors.attachment == 1"
            >
              Bitte verwenden Sie für Anhänge ausschließlich das Format PDF
            </p>
            <div class="modal__control_action">
              <p class="modal__control_actionwrapper">
                <span
                  class="modal__control_cancel modal-close-action modal__error-button"
                  @click="closeErrorModal"
                >
                  <span
                    v-if="
                      this.errors.countAccepted > 0 &&
                      this.errors.attachment != 1
                    "
                    >weiter</span
                  >
                  <span v-else>ok</span>
                </span>
              </p>
            </div>
            <div
              v-if="this.errors.countError0 > 0"
              class="notice notice--lightgreen notice--modal"
            >
              <p class="notice__title">
                <span class="notice__titlehint">Hinweis</span>
                <span v-html="this.lang['ErrorType0Title']"></span>
              </p>
              <p v-html="this.lang['ErrorType0Par1']"></p>
              <p v-html="this.lang['ErrorType0Par2']"></p>
              <p>
                <a
                  class="cta cta--medium cta--modify cta--maxw280-auto"
                  :href="this.config.routes.ebrief_enquiry_ftpadmission"
                >
                  <span class="cta__wrapper">
                    <span class="cta__icon"> &#xeaa0; </span>
                    <span
                      class="cta__text"
                      v-html="this.lang['ErrorType0CtaText']"
                    ></span>
                  </span>
                </a>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import UploadError from "./UploadError";

export default {
  name: "UploadErrorModal",
  components: {
    UploadError
  },
  props: {
    configdata: {
      type: Object,
      default: () => ({})
    },
    errordata: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    closeErrorModal() {
      let goToControl = false;
      if (this.errors.countAccepted > 0) {
        goToControl = this.errors.jobType;
      }
      this.errors.attachment = 0;
      this.$emit("close-error-modal", goToControl);
    }
  },
  computed: {
    config: function () {
      return configdata;
    },
    lang: function () {
      return configdata.settings.uploadValidation.lang;
    },
    errors: function () {
      return this.errordata;
    }
  }
};
</script>
